import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HeadSideVirus = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M272 240a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64-64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm301.2 99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9 207.9 0 0 0 266.09 0H192C86 0 0 86 0 192a191.23 191.23 0 0 0 64 142.81V512h256v-64h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.2-45zM368 240h-12.12c-28.51 0-42.79 34.47-22.63 54.63l8.58 8.57a16 16 0 1 1-22.63 22.63l-8.57-8.58c-20.16-20.16-54.63-5.88-54.63 22.63V352a16 16 0 0 1-32 0v-12.12c0-28.51-34.47-42.79-54.63-22.63l-8.57 8.58a16 16 0 0 1-22.63-22.63l8.58-8.57c20.16-20.16 5.88-54.63-22.63-54.63H112a16 16 0 0 1 0-32h12.12c28.51 0 42.79-34.47 22.63-54.63l-8.58-8.57a16 16 0 0 1 22.63-22.63l8.57 8.58c20.16 20.16 54.63 5.88 54.63-22.63V96a16 16 0 0 1 32 0v12.12c0 28.51 34.47 42.79 54.63 22.63l8.57-8.58a16 16 0 0 1 22.63 22.63l-8.58 8.57c-20.16 20.16-5.88 54.63 22.63 54.63H368a16 16 0 0 1 0 32z"
  }));
});
HeadSideVirus.displayName = 'HeadSideVirus';
export var HeadSideVirusDimensions = {
  height: 512,
  width: 512
};